import { memo, useMemo } from 'react';

import ErrorBoundary from '@/components/atomic/atoms/utils/error-boundary';
import withExposer from '@/hocs/with-exposer';
import loadableRetry from '@/utils/loadable-retry';
import loadable from '@loadable/component';

const SlideContentHandlerComponent: React.FC<{
	index: number;
	segment: string;
}> = ({ index, segment }) => {
	const choosenLevel = useMemo(() => {
		switch (index) {
			case 0:
				return 'mobile-root';
			case 1:
				return 'mobile-secondary';
			case 2:
				return 'mobile-swipeable';
			default:
				return 'mobile-root';
		}
	}, [index]);

	const LazyComponent = useMemo(
		() =>
			loadable(() =>
				loadableRetry(
					() =>
						import(
							`@/components/atomic/molecules/utils/portals/mobile-menu-container/slide-content-handler/levels/${choosenLevel}/index.tsx`
						),
				),
			),
		[choosenLevel],
	);

	return (
		<ErrorBoundary>
			<LazyComponent segment={segment} />
		</ErrorBoundary>
	);
};

const SlideContentHandler = memo(
	withExposer(SlideContentHandlerComponent, 'slideContentHandler'),
);

export default SlideContentHandler;
